import { Building2, Store } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from 'app/javascript/components/ui/avatar';

interface StoreHeaderProps {
  academyName: string | null;
  logoUrl: string | null;
  loading: boolean;
}

export default function StoreHeader({ academyName, logoUrl, loading }: StoreHeaderProps) {
  return (
    <header className="relative overflow-hidden border-b border-border/40">
      <div className="absolute inset-0 bg-gradient-to-br from-yellow-400/[0.07] via-background to-background" />
      <div className="pointer-events-none absolute -right-24 -top-24 size-[420px] rounded-full bg-yellow-400/10 blur-[120px]" />

      <div className="relative mx-auto max-w-5xl px-4 pb-10 pt-10 sm:px-6 sm:pb-12 sm:pt-14">
        <p className="mb-3 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.32em] text-yellow-400/80">
          <Store className="size-3.5" aria-hidden />
          Loja oficial
        </p>

        <div className="flex items-center gap-5">
          <Avatar className="size-16 shrink-0 rounded-2xl bg-card shadow-xl ring-1 ring-border/50 sm:size-20">
            {logoUrl ? <AvatarImage src={logoUrl} alt={academyName ?? ''} className="object-cover" /> : null}
            <AvatarFallback className="rounded-2xl bg-card">
              <Building2 className="size-8 text-muted-foreground" />
            </AvatarFallback>
          </Avatar>

          <div className="min-w-0">
            <h1 className="font-bebas text-4xl leading-[0.95] tracking-tight text-foreground sm:text-6xl">
              {academyName ?? (loading ? 'Carregando...' : 'Loja')}
            </h1>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted-foreground sm:text-base">
              Produtos oficiais da equipe. Escolha o seu e fale direto no WhatsApp para comprar.
            </p>
          </div>
        </div>
      </div>
    </header>
  );
}
